// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__HdcUy","wrapper__date":"Editable_wrapper__date__KgPCd"};